export enum RecruiterEvent {
  CANDIDATE_MOVED = 'CANDIDATE_MOVED',
  CANDIDATE_REJECTED = 'CANDIDATE_REJECTED',
  CANDIDATE_RESTORED = 'CANDIDATE_RESTORED',
  CANDIDATED_SUBMITTED = 'CANDIDATED_SUBMITTED',
  CANDIDATE_NOTE = 'CANDIDATE_NOTE',
  JOB_DELETED = 'JOB_DELETED',
  OFFER_MADE = 'OFFER_MADE',
}

export enum EmployerEvent {
  CANDIDATE_ASSIGNED = 'CANDIDATE_ASSIGNED',
  CANDIDATE_DELETED = 'CANDIDATE_DELETED',
  CANDIDATE_NOTE = 'CANDIDATE_NOTE',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  INVOICE_SENT = 'INVOICE_SENT',
}
